import { Tabs } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import { isArray } from 'lodash';
import * as React from 'react';
import { getColorMantine } from '../../../../../../react-commons/components/inputs/text-fields/types';
import { formatToPascalCase } from '../../../../../../react-commons/utils/utilFunctions';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { DetailedValidationResource } from '../../../../resource/resources/validation/detailedValidationResource';
import { ResourceDetailsComponent } from '../../validation/ResourceDetailsComponent';
import { ValidationResourceResultComponent } from './ValidationResourceResultComponent';

export const ResourceDetailsDialogContent= ({ resourceValidation, resourceType }: {
    resourceValidation?: DetailedValidationResource;
    resourceType: ResourceType | ResourceType[];
}) => {
    const [selectedTab, setSelectedTab] = React.useState<string | null>(
        resourceValidation?.maxSeverity ? 'Validation'
        : isArray(resourceType) ? resourceType[0]
        : resourceType
    );

    const getLabel = (type: ResourceType | undefined): string => {
        return `${type ? formatToPascalCase(type) : 'Resource'} Info`;
    };

    if (resourceValidation?.maxSeverity && isArray(resourceType)) {
        return (
            <div style={{ minWidth: 1200 }}>
                <Tabs value={selectedTab} onChange={setSelectedTab}>
                    <Tabs.List>
                        <Tabs.Tab
                            value={'Validation'}
                            style={{ height: 28, minHeight: 28 }}
                            rightSection={
                                <IconExclamationCircle color={getColorMantine(resourceValidation.maxSeverity)} />
                            }
                        >
                            Validation
                        </Tabs.Tab>
                        {resourceType.map((value) => (
                            <Tabs.Tab key={value} style={{ height: 28, minHeight: 28 }} value={value}>
                                {getLabel(value)}
                            </Tabs.Tab>
                        ))}
                    </Tabs.List>
                    <Tabs.Panel mih={550} value={'Validation'}>
                        <ValidationResourceResultComponent
                            maxSeverity={resourceValidation.maxSeverity}
                            resourceValidation={resourceValidation}
                            persistableTypeGroup={resourceValidation?.resourceType ?? ''}
                        />
                    </Tabs.Panel>
                    {resourceType.map((value) => (
                        <Tabs.Panel mih={550} key={value} value={value}>
                            <ResourceDetailsComponent resourceType={value} />
                        </Tabs.Panel>
                    ))}
                </Tabs>
            </div>
        );
    } else if (resourceValidation?.maxSeverity && !isArray(resourceType)) {
        return (
            <div style={{ minWidth: 1200 }}>
                <Tabs value={selectedTab} onChange={setSelectedTab}>
                    <Tabs.List>
                        <Tabs.Tab
                            value={'Validation'}
                            style={{ height: 28, minHeight: 28 }}
                            rightSection={
                                <IconExclamationCircle color={getColorMantine(resourceValidation.maxSeverity)} />
                            }
                        >
                            Validation
                        </Tabs.Tab>
                        <Tabs.Tab key={resourceType} style={{ height: 28, minHeight: 28 }} value={resourceType}>
                            {getLabel(resourceType)}
                        </Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel mih={550} value={'Validation'}>
                        <ValidationResourceResultComponent
                            maxSeverity={resourceValidation.maxSeverity}
                            resourceValidation={resourceValidation}
                            persistableTypeGroup={resourceValidation?.resourceType ?? ''}
                        />
                    </Tabs.Panel>
                    <Tabs.Panel mih={550} key={resourceType} value={resourceType} style={{ padding: 6 }}>
                        <ResourceDetailsComponent resourceType={resourceType} />
                    </Tabs.Panel>
                </Tabs>
            </div>
        );
    }

    if (isArray(resourceType)) {
        return (
            <div style={{ minWidth: 1200 }}>
                <Tabs value={selectedTab} onChange={setSelectedTab}>
                    <Tabs.List>
                        {resourceType.map((value) => (
                            <Tabs.Tab key={value} style={{ height: 28, minHeight: 28 }} value={value}>
                                {getLabel(value)}
                            </Tabs.Tab>
                        ))}
                    </Tabs.List>
                    {resourceType.map((value) => (
                        <Tabs.Panel mih={550} key={value} value={value}>
                            <ResourceDetailsComponent resourceType={value} />
                        </Tabs.Panel>
                    ))}
                </Tabs>
            </div>
        );
    }

    return (
        <div style={{ minWidth: 1200 }}>
            <ResourceDetailsComponent resourceType={resourceType} />
        </div>
    );
};


